export enum ScopeCalculatorPropsEnums {
  LOCAL_STORAGE_SCOPE_PAYLOAD = 'scopePayload',
  LOCAL_STORAGE_SCOPE_EMISSIONS = 'scopeCalculation',
  SCOPE_CALCULATOR = 'scopeCalculator',
  HEADING = 'Scope 1 & Scope 2 Calculator',
  CANCEL = 'Cancel',
  PROCEED = 'Proceed',
  CALCULATE = 'Calculate',
  SCOPE_1 = 'scope1',
  SCOPE_2 = 'scope2',
  PROCESSING_FACILITY_SCOPE_1 = 'Processing Facility Scope 1',
  PROCESSING_FACILITY_SCOPE_2 = 'Processing Facility Scope 2',
  TOTAL_SCOPE_1 = 'Total Scope 1 (tonnes CO\u2082)e',
  TOTAL_SCOPE_2 = 'Total Scope 2 (tonnes CO\u2082)e',
  EMPTY_STRING = '',
}
